import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { useHttpUtils } from '../../Utilities/useHttpUtils';
import useAlert from '../../Alerts/useAlert';
import AdminTile from './AdminTile';

export default function CreateEmail() {
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const [variant, setVariant] = useState<string>("");
    const [error, setError] = useState<string | null>();
    const [email, setEmail] = useState({
        to: "",
        subject: "",
        content: "",
    });

    const sendEmail = () => {
        fetchDataAuthenticated("api/v1/admin/createEmail", "POST", JSON.stringify(email))
            .then(response => {
                if (!response.ok) {
                    return response
                        .json()
                        .then(error => Promise.reject(error));
                }
                return response;
            })
            .then(data => {
                setVariant("");
                setError(null);
                setAlert("success", "Created Email", "Email successfully created and queued to send")
            }).catch(error => {
                setVariant("danger");
                setAlert("danger", "Failed to send email", error.detail)
                setError(error.detail);
            });
    };

    return (
        <AdminTile
            title={"Send Email"}
            description={"Send email"}
            variant={variant}>
            <>
                <Form>
                    <Form.Group>
                        <Form.Label><strong>To</strong></Form.Label>
                        <Form.Control type="text" value={email.to} onChange={(e) => setEmail({ ...email, to: e.target.value })} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label><strong>Subject</strong></Form.Label>
                        <Form.Control type="text" value={email.subject} onChange={(e) => setEmail({ ...email, subject: e.target.value })} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label><strong>Content</strong></Form.Label>
                        <Form.Control type="text" value={email.content} onChange={(e) => setEmail({ ...email, content: e.target.value })} />
                    </Form.Group>
                </Form>
                <Button type="submit" className="ms-auto mt-auto" onClick={sendEmail}>Send</Button>
                {error &&
                    <div>
                        {error}
                    </div>
                }
            </>
        </AdminTile>
    );
}